import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon/Icon";
import Translate from "react-translate-component";
import { Tooltip } from "bitshares-ui-style-guide";
export default class Showcase extends Component {
  static propTypes = {
    target: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    comingSoon: PropTypes.bool
  };
  static defaultProps = {
    disabled: false
  };

  constructor() {
    super();
  }

  render() {
    if (!!this.props.disabled || !!this.props.comingSoon) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: typeof this.props.disabled == "string" ? this.props.disabled : "Coming soon"
      }, /*#__PURE__*/React.createElement("div", {
        className: "showcases-grid--wrapper--item--wrapper--disabled disabled",
        onClick: () => {},
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "no-margin"
      }, !!this.props.comingSoon && /*#__PURE__*/React.createElement(Icon, {
        style: {
          float: "right"
        },
        name: "coming_soon",
        size: "4x"
      }), /*#__PURE__*/React.createElement(Translate, {
        content: this.props.title
      })), /*#__PURE__*/React.createElement("div", {
        className: "showcases-grid--wrapper--item--wrapper--content disabled"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: this.props.icon,
        size: "5x"
      }), /*#__PURE__*/React.createElement("span", {
        className: "padding showcases-grid--wrapper--item--wrapper--content--description disabled"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: this.props.description
      })))));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "showcases-grid--wrapper--item--wrapper",
        onClick: this.props.target,
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: this.props.title,
        className: "no-margin",
        component: "h2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "showcases-grid--wrapper--item--wrapper--content"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: this.props.icon,
        size: "5x"
      }), /*#__PURE__*/React.createElement("span", {
        className: "padding showcases-grid--wrapper--item--wrapper--content--description"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: this.props.description
      }))));
    }
  }

}